import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import ManagedCompanyForm from "components/companies/ManagedCompanyForm";
import { createManagedCompany } from "graphql/mutations";
import { managedCompaniesByParentID } from "graphql/queries";

const ManagedCompanyCreateForm = ({ companyID, onSuccess }) => {
  const navigate = useNavigate();
  const managedCompany = {
    companyID: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { companyID: childID } = valuesParam;
      const oldManagedCompanyData = await API.graphql(
        graphqlOperation(managedCompaniesByParentID, {
          parentID: companyID,
          filter: {
            and: [
              {
                childID: { eq: childID },
              },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const oldManagedCompanyItems =
        oldManagedCompanyData.data.managedCompaniesByParentID.items;

      if (oldManagedCompanyItems.length > 0) {
        toast.error(strings.companyExists);
        return;
      }

      if (childID === companyID) {
        toast.error(strings.sameCompany);
        return;
      }

      await API.graphql({
        query: createManagedCompany.replaceAll("__typename", ""),
        variables: {
          input: {
            parentID: companyID,
            childID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/companies");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <ManagedCompanyForm onSubmit={onSubmit} initialValues={managedCompany} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Empresa Administrada",
    successAdded: "Empresa Administrada agregada con éxito",
    companyExists:
      "La empresa administrada ya existe en la empresa seleccionada",
    sameCompany: "No se puede administrar la misma empresa",
  },
});

export default ManagedCompanyCreateForm;
